module.exports = __webpack_public_path__ + "img/Support-skill-218.0fa6931d.png";